/* ==========================================================================
   Product configurator - site skin enhancements
   Adds reference-style controls on top of the configurator's own selects:
     - metal swatches for #metal-select
     - size boxes (with "Show all sizes") for #finger-size-select
   The original selects stay in the page (visually hidden) and remain the source
   of truth: clicking a swatch/box sets the select and fires its "change" event,
   so all configurator logic (prices, SKUs, images) runs unchanged.
   Also opens the Specifications accordion when "View Full Details" is used.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('jewelry-configurator');
  if (!root || root.dataset.skin) return;
  root.dataset.skin = '1';

  function metalColor(text) {
    var t = String(text || '').toLowerCase();
    if (t.indexOf('yellow') > -1 || /\b\d{2}k?y\b/.test(t)) return '#dcb84e';
    if (t.indexOf('rose') > -1 || /\b\d{2}k?r\b/.test(t)) return '#dabba9';
    if (t.indexOf('plat') > -1 || t.indexOf('pallad') > -1) return '#c5c1bd';
    return '#d0d0d0';
  }

  function fire(select) {
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function labelFor(select) {
    var group = select.closest('.jc-select-group');
    return group ? group.querySelector('.jc-select-label') : null;
  }

  function setLabelValue(select, prefix) {
    var label = labelFor(select);
    if (!label) return;
    if (!label.dataset.base) label.dataset.base = prefix || label.textContent.trim();
    var opt = select.options[select.selectedIndex];
    var value = opt ? opt.textContent.replace(/\s*\(.*\)\s*$/, '').trim() : '';
    label.innerHTML = '';
    label.appendChild(document.createTextNode(label.dataset.base + (value ? ': ' : '')));
    if (value) {
      var span = document.createElement('span');
      span.className = 'jc-label-value';
      span.textContent = value;
      label.appendChild(span);
    }
  }

  /* ---------- Metal swatches ---------- */
  function buildMetal() {
    var select = document.getElementById('metal-select');
    if (!select) return;
    var wrap = select.closest('.jc-select-wrap');
    var row = root.querySelector('[data-skin-metals]');
    if (!row) {
      row = document.createElement('ul');
      row.className = 'jc-skin-swatches';
      row.setAttribute('data-skin-metals', '');
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Metal');
      wrap.parentNode.insertBefore(row, wrap);
      wrap.classList.add('jc-skin-hidden');
      row.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b) return;
        if (select.value !== b.dataset.value) { select.value = b.dataset.value; fire(select); }
        sync();
      });
    }
    row.innerHTML = '';
    Array.prototype.forEach.call(select.options, function (o) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jc-skin-metal';
      b.dataset.value = o.value;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', o.textContent.trim());
      b.title = o.textContent.trim();
      var dot = document.createElement('span');
      dot.style.background = metalColor(o.textContent + ' ' + o.value);
      b.appendChild(dot);
      li.appendChild(b);
      row.appendChild(li);
    });
    sync();
  }

  /* ---------- Size boxes ---------- */
  var showAllSizes = false;
  function buildSizes() {
    var select = document.getElementById('finger-size-select');
    if (!select) return;
    var wrap = select.closest('.jc-select-wrap');
    if (!select.options.length) return;
    var box = root.querySelector('[data-skin-sizes]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'jc-skin-sizes';
      box.setAttribute('data-skin-sizes', '');
      box.setAttribute('role', 'radiogroup');
      box.setAttribute('aria-label', 'Finger size');
      wrap.parentNode.insertBefore(box, wrap);
      var note = document.createElement('p');
      note.className = 'jc-skin-upcharge';
      note.setAttribute('data-skin-upcharge', '');
      wrap.parentNode.insertBefore(note, wrap);
      wrap.classList.add('jc-skin-hidden');
      box.addEventListener('click', function (e) {
        var more = e.target.closest('[data-skin-more]');
        if (more) { showAllSizes = !showAllSizes; buildSizes(); return; }
        var b = e.target.closest('[data-value]');
        if (!b) return;
        if (select.value !== b.dataset.value) { select.value = b.dataset.value; fire(select); }
        sync();
      });
    }
    box.innerHTML = '';
    var hiddenCount = 0;
    Array.prototype.forEach.call(select.options, function (o) {
      if (!o.value && !o.textContent.trim()) return;
      var text = o.textContent.replace(/\s*\(.*\)\s*$/, '').trim();
      var whole = /^\d+(\.0+)?$/.test(text) || /^\d+\.5$/.test(text) || isNaN(parseFloat(text));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jc-skin-size';
      b.dataset.value = o.value;
      b.setAttribute('role', 'radio');
      b.textContent = text;
      if (!showAllSizes && !whole && o.value !== select.value) { b.hidden = true; hiddenCount++; }
      box.appendChild(b);
    });
    if (hiddenCount || showAllSizes) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'jc-skin-more';
      more.setAttribute('data-skin-more', '');
      more.textContent = showAllSizes ? 'Show Fewer Sizes' : 'Show All Sizes';
      box.appendChild(more);
    }
    sync();
  }

  /* ---------- Keep swatches/boxes in step with the selects ---------- */
  function sync() {
    var metal = document.getElementById('metal-select');
    if (metal) {
      root.querySelectorAll('.jc-skin-metal').forEach(function (b) {
        var on = b.dataset.value === metal.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setLabelValue(metal, 'Metal');
    }
    var size = document.getElementById('finger-size-select');
    if (size) {
      root.querySelectorAll('.jc-skin-size').forEach(function (b) {
        var on = b.dataset.value === size.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setLabelValue(size, 'Size');
      var note = root.querySelector('[data-skin-upcharge]');
      var opt = size.options[size.selectedIndex];
      var m = opt && opt.textContent.match(/\(([^)]*)\)/);
      if (note) note.textContent = m ? 'Price for this size: ' + m[1] : '';
    }
  }

  function watch(id, build) {
    var el = document.getElementById(id);
    if (!el) return;
    new MutationObserver(function () { build(); }).observe(el, { childList: true });
    el.addEventListener('change', sync);
    build();
  }

  function init() {
    watch('metal-select', buildMetal);
    watch('finger-size-select', buildSizes);
    var stone = document.getElementById('stone-size-select');
    if (stone) {
      stone.addEventListener('change', function () { setLabelValue(stone, 'Primary Stone Size'); });
      new MutationObserver(function () { setLabelValue(stone, 'Primary Stone Size'); }).observe(stone, { childList: true });
      setLabelValue(stone, 'Primary Stone Size');
    }
    var details = document.getElementById('btn-full-details');
    var specs = document.getElementById('specifications');
    if (details && specs) {
      details.addEventListener('click', function () {
        if (specs.tagName === 'DETAILS') specs.open = true;
        setTimeout(function () { specs.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
